import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import RichText from '@/components/rich-text'
import {Text} from '@/components/text'
import {Section} from '@/styles/grid'
import mq from '@/utils/media-query'

import type {RichTextSliceFragment} from '@/graphql-types'

export const RichTextSlice = ({slice}: {slice: RichTextSliceFragment}) => (
    <Section>
        <ContentWrapper>
            <Text as="h1" $variant="heading-large">
                {slice.primary.title}
            </Text>
            <RichText $color="muted" content={slice.primary.copy.richText} />
        </ContentWrapper>
    </Section>
)

const ContentWrapper = styled.div`
    max-width: 860px;
    display: grid;
    gap: ${({theme}) => theme.spacings.s40};

    ${mq.min('md')} {
        gap: ${({theme}) => theme.spacings.s60};
    }
`

export const richTextSliceFragment = graphql`
    fragment RichTextSlice on PrismicSlicePageDataBodyRichText {
        __typename
        primary {
            title
            copy {
                richText
            }
        }
    }
`
